import { StatusBadge, type StatusBadgePalette } from "@components";
import {
	EVENT_BADGE_VARIANT_CLASSES,
	EVENT_TYPE_UI,
	type EventBadgeVariant,
} from "../events/events.config";
import type { EventTypeCode } from "../types/events";

function getEventTypeLabel(code: number): string {
	if (code >= 1 && code <= 13) {
		return EVENT_TYPE_UI[code as EventTypeCode].listTitle;
	}
	return `Tipo ${code}`;
}

function getBadgeVariant(code: number): EventBadgeVariant {
	if (code >= 1 && code <= 13) {
		return EVENT_TYPE_UI[code as EventTypeCode].badgeVariant;
	}
	return "amber";
}

export function getEventBadgePalette(
	variant: EventBadgeVariant
): StatusBadgePalette {
	const styles = EVENT_BADGE_VARIANT_CLASSES[variant];
	return {
		root: `${styles.border} ${styles.bg}`,
		dot: styles.dot,
		label: styles.text,
	};
}

export function EventTypeBadge({ eventType }: { eventType: number }) {
	return (
		<StatusBadge
			label={getEventTypeLabel(eventType)}
			palette={getEventBadgePalette(getBadgeVariant(eventType))}
		/>
	);
}
